import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import Dialog         from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle    from '@material-ui/core/DialogContent';
import TextField      from '@material-ui/core/TextField';

import { create } from '../util';

const style = {
  newAttender: makeStyles((theme) => ({
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  })),
};

export default function NewAttender(props) {
  const classes = style.newAttender();

  const {
    newAttender,
    setNewAttender,
    setSnackbarMessage,
  } = props.context.getStates();

  return (
    <Dialog fullWidth open={newAttender.rowid === -1}>
      <DialogTitle>{'새 참가자 추가'}</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <TextField label="이름"
          onChange={(event) => {
            setNewAttender((oldAttender) => ({
              ...oldAttender, name: event.target.value,
            }));
          }}
          value={newAttender.name}
        />

        <TextField label="이메일"
          onChange={(event) => {
            setNewAttender((oldAttender) => ({
              ...oldAttender, email: event.target.value,
            }));
          }}
          value={newAttender.email}
        />

        <TextField label="전화번호"
          onChange={(event) => {
            setNewAttender((oldAttender) => ({
              ...oldAttender, phone: event.target.value,
            }));
          }}
          value={newAttender.phone}
        />

        <TextField multiline rows={4} label={'비고'}
          onChange={(event) => {
            setNewAttender((oldAttender) => ({
              ...oldAttender, note: event.target.value,
            }));
          }}
          value={newAttender.note}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={(event) => { setNewAttender(create.attender()); }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => {
          if (newAttender.name === '') {
            setSnackbarMessage('[추가 불가능] 이름을 입력해 주세요.');
          } else {
            props.updateAttender(newAttender);
          }
        }}>{'확인'}</Button>
      </DialogActions>
    </Dialog>
  );
}
